import { useEffect, useState } from 'react';

const CYCLE_SECONDS = 17 * 60 + 34;
const START = Date.now();

function remaining(): number {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  return CYCLE_SECONDS - (elapsed % CYCLE_SECONDS);
}

export function useCountdown() {
  const [secs, setSecs] = useState(remaining);

  useEffect(() => {
    const id = window.setInterval(() => setSecs(remaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return { hours: pad(h), minutes: pad(m), seconds: pad(s) };
}
